/** Lifecycle of a tenant (an optical company) on the platform. */
export const TenantStatus = {
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
} as const;
export type TenantStatus = (typeof TenantStatus)[keyof typeof TenantStatus];

/** Tenant states that are allowed to authenticate and use the API. */
export const OPERATIONAL_TENANT_STATUSES: readonly TenantStatus[] = [
  TenantStatus.TRIAL,
  TenantStatus.ACTIVE,
];

export const UserStatus = {
  INVITED: 'INVITED',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  DISABLED: 'DISABLED',
} as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

/** Distinguishes SaaS-provider staff from users belonging to an optical company. */
export const UserScope = {
  PLATFORM: 'PLATFORM',
  TENANT: 'TENANT',
} as const;
export type UserScope = (typeof UserScope)[keyof typeof UserScope];

export const AuditAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  /** Status transitions. Generic: `entityType` says what was activated. */
  ACTIVATE: 'ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  LOGIN: 'LOGIN',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGOUT: 'LOGOUT',
  TOKEN_REFRESH: 'TOKEN_REFRESH',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  BRANCH_SWITCH: 'BRANCH_SWITCH',
  /** A clinical record was read in full. The entry names the record and the reader, never what it said. */
  VIEW: 'VIEW',
  /** A report was downloaded. The entry names what was exported and how many rows, never a row itself. */
  EXPORT: 'EXPORT',
} as const;
export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const SupportedLocale = {
  EN: 'en',
  AR: 'ar',
} as const;
export type SupportedLocale = (typeof SupportedLocale)[keyof typeof SupportedLocale];

export const TextDirection = {
  LTR: 'ltr',
  RTL: 'rtl',
} as const;
export type TextDirection = (typeof TextDirection)[keyof typeof TextDirection];

export const LOCALE_DIRECTION: Record<SupportedLocale, TextDirection> = {
  en: TextDirection.LTR,
  ar: TextDirection.RTL,
};
